<template>
  <div class="y-bk-fff y-mt-10 y-pd-20 staff-content">
    <div class="y-mt-15 y-mb-15">
      <span class="y-fc-F56C6C">*</span>
      <span class="y-fs-14 y-fc-333 y-fw-500">角色名称</span>
      <el-input
        placeholder="请输入角色名称"
        size="mini"
        class="y-w-180"
        :disabled="readonly"
        v-model="roleForm.roleName">
      </el-input>
      <span v-if="readonly" class="y-fc-4C84FF y-c-p y-fs-12 y-ml-5" @click="goCreate">角色权限不满足需求？去创建新角色</span>
    </div>
    <div class="y-pl-10 y-mb-15">
      <el-checkbox
        :disabled="readonly"
        v-model="checkedAllAuth"
        :indeterminate="halfCheckedAllAuth"
        @change="chooseAllAuth">
      </el-checkbox>
      <span class="y-fc-333 y-fs-14 y-fw-500">分配所有客户编码/店铺权限和菜单权限</span>
    </div>
    <el-collapse v-model="activeName">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="coll-title">
            <span class="y-fc-F56C6C">*</span>
            <span class="maint">客户编码/店铺权限</span>
            <span class="maini">（该角色的员工不用绑定，直接可以使用）</span>
          </div>
        </template>
        <shopAuth
          :isCreate="isCreate"
          @getKCodeChooseStatus="getKCodeChooseStatus"
          ref="shopAuth"
          v-if="roleInfoListGet"
          :roleForm="roleForm"
          :readonly="readonly" />
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="coll-title">
            <span class="y-fc-F56C6C">*</span>
            <span class="maint">菜单权限</span>
            <span class="maini">（该角色可查看以下菜单）</span>
          </div>
        </template>
        <authTable
          :isAdministrators="isAdministrators"
          @getMenuAuthStatus="getMenuAuthStatus"
          ref="authTable"
          :roleName="$route.params.editName"
          :roleId="$route.params.editId"
          :sourceData="sourceData"
          :readonly="readonly"
        />
      </el-collapse-item>
    </el-collapse>
    <div class="staff-footer">
      <template v-if="$route.name != 'SeeRole'">
        <el-button class="y-w-100" @click="cancel">取消</el-button>
        <el-button class="y-w-100" @click="confirm" type="primary">保存</el-button>
      </template>
      <template v-if="$route.name == 'SeeRole'">
        <el-button class="y-w-100" @click="close" type="primary">关闭</el-button>
      </template>

      <el-button class="y-w-100 delete-btn" v-if="$route.params.editId && $route.params.editName != '普通员工' && $route.params.editName != '管理员'" @click="delRole">删除角色</el-button>
    </div>
  </div>
</template>
<script>
import { addUserRoleApi, getRoleListApi } from '../../../../api/baseInfo/staffManage/employeeMgr';
import { modifyYcRoleMenuApi, userRoleDeleteApi, viewRolePreApi } from '@/api/baseInfo/staffManage/roleMgr';
export default {
  data() {
    return {
      roleInfoListGet: false,
      sourceData: null,
      roleForm: {
        roleName: '',
        roleId: '',
        roleInfoList: [],
      },
      halfCheckedAllCode: false,
      activeName: ['1', '2'],
      checkedAllCode: false, // k码权限选中状态
      halfCheckedAllCode: false,
      checedMenuAuthAll: false, // 菜单权限选中状态
      checedMenuAuthHalf: false,
      isAdministrators: false,
      roleOptions: [], // 获取所有的角色
      isCreate: false
    }
  },
  mounted() {
    if(this.$route.name === 'CreateRole') {
      // 创建角色的时候需要筛选出普通员工作为权限默认值
      this.queryRoleList();
      this.isCreate = true;
    } else {
      this.getRoleAuth();
    }
  },
  methods: {
    // 获取角色类型
    queryRoleList() {
      let params = {
        groupId: this.userMess.groupId
      };
      getRoleListApi(params).then(res => {
        if (res.success) {
          this.roleOptions = res.data.roleList;
          this.getRoleAuth();
        }
      }).catch(err => {
        console.log(err);
      });
    },
    goCreate() {
      // 创建角色
      this.$router.push({
        name: 'CreateRole',
        params: {}
      })
    },
    cancel() {
      this.$router.push({
        name: 'RoleManagement'
      })
    },
    delRole() {
      // 删除角色
      this.$confirm('<span class="y-fc-333 y-fs-14 y-fw-500">确认要删除角色吗？</span><br/><span class="y-fc-333 y-fs-14 y-fw-400">删除后，无法撤销操作！</span>', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        dangerouslyUseHTMLString: true,
        customClass: 'confirm-tip'
      }).then(() => {
        let loadingMask = this.$loading({
          lock: true,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.3)'
        });
        let params = {
          groupId: this.userMess.groupId,
          roleId: this.$route.params.editId
        };
        userRoleDeleteApi(params).then(res => {
          if (res.success) {
            this.$message({
              message: '删除成功！',
              type: 'success'
            });
            this.$router.push({ name: 'RoleManagement'})
          } else {
            this.$message.error(res.message);
          }
          loadingMask.close();
        }).catch((res) => {
          loadingMask.close();
          this.$message.error(res.message);
        });
      })
    },
    close() {
      if(this.$route.params.from === 'staffList') {
        this.$router.push({ name: 'UserManagement'})
      } else {
        this.$router.push({ name: 'RoleManagement'})
      }
    },
    confirm() {
      if (this.roleForm.roleName === '') {
        this.$message.error('角色名称不能为空！');
        return false;
      }
      let customerCodeAuthList = [];
      this.roleForm.roleInfoList.forEach(item => {
        if(item.checked) {
          customerCodeAuthList.push({
            kCode: item.code,
            shopCodeList: []
          })
        }
        if(item.halfCheckedAll) {
          let obj = {
            kCode: item.code,
            shopCodeList: []
          }
          item.showShopList.forEach(plat => {
            if(plat.value.length) {
              plat.value.forEach(shop => {
                let id = shop.id.substring(0, shop.id.lastIndexOf('-'));
                obj.shopCodeList.push(id)
              })
            }
          })
          customerCodeAuthList.push(obj)
        }
      })
      let menuAuthList = []; // app权限code
      let menuWebAuthList = []; // web权限
      let buttonAuthList = []; // 按钮权限
      this.$refs.authTable.khgjTableData.forEach(item => {
        if(item.appChecked) {
          menuAuthList.push(item.appCode);
        }
        if(item.pcChecked) {
          menuWebAuthList.push(item.parentMenuId);
          menuWebAuthList.push(item.webMenuId);
        }
        if(item.aBtnChecked) {
          buttonAuthList.push(item.appBtnCode)
        }
        if(item.aBtnChecked1) {
          buttonAuthList.push(item.appBtnCode1)
        }
        if(item.aBtnChecked2) {
          buttonAuthList.push(item.appBtnCode2)
        }
        if(item.pBtnChecked) {
          buttonAuthList.push(item.pcBtnCode);
        }
        if(item.pBtnChecked1) {
          buttonAuthList.push(item.pcBtnCode1);
        }
        if(item.pBtnChecked2) {
          buttonAuthList.push(item.pcBtnCode2);
        }        
      })

      let params = {
        groupId: this.userMess.groupId,
        customerCodeAuthList,
        roleId: this.roleForm.roleId || null,
        roleName: this.roleForm.roleName,
        menuAuthList,
        menuWebAuthList,
        buttonAuthList
      }
      if(this.$route.name === 'CreateRole') {
        // 如果是创建角色 roleId是 null
        params.roleId = null;
      }

      if (customerCodeAuthList.length === 0 && this.roleForm.roleInfoList.length > 0) {
        this.$message.warning('请为角色分配客户编码权限！');
        return false;
      }
      if (menuWebAuthList.length === 0) {
        this.$message.warning('请为角色分配网页端菜单权限！');
        return false;
      }
      if (menuAuthList.length === 0) {
        this.$message.warning('请为角色分配APP端菜单权限！');
        return false;
      }
      let loadingMask = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)'
      });
      addUserRoleApi(params).then(res => {
        if (res.success) {
          // 角色创建成功
          if(params.roleId) {
            this.$message.success('修改成功！');
            let ycParams = {
              groupId: this.userMess.groupId,
              ruleId: params.roleId,
              ruleCode: '', // 后端刚开始建表有这个字段，后面没改了
              ruleName: this.roleForm.roleName,
              ycMenuList: this.$refs.authTable.ycTableData,
            }
            modifyYcRoleMenuApi(ycParams).then(() => {
              // do nothing
            })
          } else {
            this.$message.success('添加成功！');
            let ycParams = {
              groupId: this.userMess.groupId,
              ruleId: res.data,
              ruleCode: '', // 后端刚开始建表有这个字段，后面没改了
              ruleName: this.roleForm.roleName,
              ycMenuList: this.$refs.authTable.ycTableData,
            }
            modifyYcRoleMenuApi(ycParams).then(() => {
              // do nothing
            })
          }
          this.$router.push({ name: 'RoleManagement'})
        } else {
          this.$message.error(res.message || '角色添加失败');
        }
        loadingMask.close();
      })
    },
    getMenuAuthStatus(obj) {
      this.checedMenuAuthAll = obj.checkedAllMenu;
      this.checedMenuAuthHalf = obj.checkedHalfMenu;
    },
    getKCodeChooseStatus(obj) {
      this.checkedAllCode = obj.checkedAllCode;
      this.halfCheckedAllCode = obj.halfCheckedAllCode;
    },
    chooseAllAuth(val) {
      // 只有全选跟半选的状态
      if(!val) {
        this.halfCheckedAllAuth = true;
      } else {
        this.halfCheckedAllAuth = false;
      }
      // 全选所有的客户编码权限
      this.$refs.authTable.chooseAllMenu(val);
      this.$refs.shopAuth.chooseAllAuthCode(val)
    },
    getRoleAuth() {
      // 获取角色权限
      let params = {
        groupId: this.userMess.groupId,
        isEdit: 1,
        roleId: null
      };
      if(this.$route.params.editId) {
        params.roleId = this.$route.params.editId;
        this.roleForm.roleName = this.$route.params.editName;
        this.roleForm.roleId = this.$route.params.editId;
      }
      if(this.$route.name === 'SeeRole') {
        // 查看
        params.isEdit = 0;
        if(this.roleForm.roleName === '管理员') {
          params.isEdit = 1;
          this.isAdministrators = true;
        } else {
          this.isAdministrators = false;
        }
      }
      let loadingMask = this.$loading({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.3)'
      });
      if(this.$route.name === 'CreateRole') {
        // 创建角色默认使用普通员工的角色
        let obj = this.roleOptions.find((item) => { // 遍历list的数据
          return item.roleCode === 'generalUser';// 筛选出匹配数据
        });
        if (obj) {
          params.roleId = obj.roleId;
          this.roleForm.roleId = obj.roleId;
        }
        // 创建员工只使用普通员工默认的菜单权限
        viewRolePreApi({
          groupId: this.userMess.groupId,
          isEdit: 1,
          roleId: null
        }).then(res => {
          if (res.success) {
            // 客户编码权限
            let authList = res.data.roleInfoList[0].authList;
            for(let i = 0, len = authList.length; i < len; i++) {
              authList[i].halfCheckedAll = false;
            }
            this.roleForm.roleInfoList = JSON.parse(JSON.stringify(authList));
          }
        })
      }
      this.roleInfoListGet = false;
      viewRolePreApi(params).then(res => {
        this.roleInfoListGet = true;
        if (res.success) {
          // 客户编码权限
          if(this.$route.name !== 'CreateRole') {
            let authList = res.data.roleInfoList[0].authList;
            for(let i = 0, len = authList.length; i < len; i++) {
              authList[i].halfCheckedAll = false;
            }
            this.roleForm.roleInfoList = JSON.parse(JSON.stringify(authList));
          }

          // app 菜单权限， web菜单权限
          this.sourceData = res.data;
        }
        loadingMask.close();
      })
    },
  },
  computed: {
    userMess() {
      return this.$store.state.user;
    },
    readonly() {
      return this.$route.name === 'SeeRole'
    },
    checkedAllAuth: {
      get() {
        return this.checkedAllCode && this.checedMenuAuthAll;
      },
      set() { } 
    },
    halfCheckedAllAuth: {
      // 只有全选和半选的状态
      get() {
        return !this.checkedAllCode || !this.checedMenuAuthAll;
      },
      set() { }
    }
  },
  components: {
    shopAuth: () => import('../employeeMgr/components/shopAuth.vue'),
    authTable: () => import('./components/authTable.vue'),
  },
}
</script>
<style lang="scss" scoped>
@import "../../../../styles/variables";
.staff-content {
  padding-bottom: 50px;
}
.staff-footer {
  box-shadow: 0px -2px 4px 0px rgba(199, 199, 199, 0.5);
  position: fixed;
  bottom: 0;
  left: 160px;
  text-align: center;
  width: calc(100% - 170px);
  padding: 10px 0;
  background-color: #fff;
  z-index: 99;
}
/deep/ .el-collapse-item__arrow {
  margin: 0;
}
.coll-title {
  border-left: 2px solid $blue-style;
  height: 22px;
  line-height: 22px;
  padding-left: 5px;
  .maint {
    font-size: 16px;
    color: #383838;
    font-weight: 500;
  }
  .maini {
    font-size: 12px;
    color: #999;
    font-weight: 400;
  }
}
</style>
